import { applyMiddleware, createStore, Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import { config } from './config';
import type { AppStore } from './hooks/redux-types';
import { root } from './reducers/root';

const middlewares: Middleware[] = [thunk as unknown as Middleware];

if (config.Env !== 'production') {
    middlewares.push(createLogger({ collapsed: true }) as Middleware);
}

const enhancers = applyMiddleware(...middlewares);

export const store = createStore(root, enhancers) as AppStore;
